function getReviewInvites(invites) {
  return invites.filter(({ status }) => status === 'review');
}

export function invitationHasGarageProposedDates({ proposedChanges }) {
  return proposedChanges?.some(
    ({ status, updatedBy, value }) => status === 'proposed' && updatedBy === 'garage' && value
  );
}

export function invitationHasCaseManagerReviewedDates({ proposedChanges }) {
  return proposedChanges?.some(
    ({ status, updatedBy, value }) => status === 'reviewed' && updatedBy === 'case-manager' && value
  );
}

export function invitationHasCustomerConfirmedDates({ proposedChanges }) {
  return proposedChanges?.some(
    ({ status, updatedBy, value }) => status === 'confirmed' && updatedBy === 'customer' && value
  );
}

export function invitesHaveGarageProposedProposedChanges(invites = []) {
  return getReviewInvites(invites).some(invitationHasGarageProposedDates);
}

export function invitesHaveCaseManagerReviewedProposedChanges(invites = []) {
  return getReviewInvites(invites).some(invitationHasCaseManagerReviewedDates);
}

export function invitesHaveCustomerConfirmedProposedChanges(invites = []) {
  return getReviewInvites(invites).some(invitationHasCustomerConfirmedDates);
}
